import React from "react";
import { Routes, Route } from "react-router-dom";
import { Portfolios, PortfoliosAdd, PortfoliosEdit } from "../../../pages";

const PortfoliosRoutes = () => {
  return (
    <Routes>
      <Route path={`:id`} element={<PortfoliosEdit />} />
      <Route path={`add`} element={<PortfoliosAdd />} />
      <Route path="" element={<Portfolios />} />
    </Routes>
  );
};

export default PortfoliosRoutes;
